/**
 * 分组管理页懒加载壳（14.22b；ContactApplyLazy 同构）：低频管理页不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';

export function FriendGroupsLazy() {
  const { mod } = useLazyModule(() => import('./FriendGroupsPage'));
  if (mod === null) return <div data-testid="friend-groups-loading-shell">加载中…</div>;
  return <mod.FriendGroupsPage />;
}
